module.exports = __webpack_public_path__ + "static/img/bianzu1.9f312d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bianzu1.png
// module id = dN5u
// module chunks = 2